import { Download, FileText, Upload } from "lucide-react";
import { toast } from "sonner";
import { DOCUMENTS } from "@/data/demo";
import { Btn, Card, PageHeader } from "@/components/common";

const demo = () => toast("Demo mode — this action is visual only.");

export default function Documents() {
  return (
    <div>
      <PageHeader title="Documents" subtitle="Files shared on your cases">
        <Btn data-testid="upload-document-button" variant="gold" onClick={demo}><Upload size={16} />Upload</Btn>
      </PageHeader>
      <Card data-testid="documents-list" className="divide-y divide-slate-100 overflow-hidden">
        {DOCUMENTS.map((d) => (
          <div key={d.id} data-testid={`document-${d.id}`} className="flex items-center gap-4 p-4">
            <div className="grid h-12 w-12 shrink-0 place-items-center rounded-xl bg-red-50 text-red-500"><FileText size={20} /></div>
            <div className="min-w-0 flex-1">
              <div className="truncate font-semibold text-navy">{d.name}</div>
              <div className="mt-0.5 truncate text-xs text-slate-500">{d.caseNo} · {d.size} · {d.date}</div>
            </div>
            <button data-testid={`download-${d.id}`} onClick={demo} aria-label={`Download ${d.name}`} className="grid h-11 w-11 shrink-0 place-items-center rounded-xl border border-slate-200 text-slate-500 transition-colors hover:border-amber-300 hover:text-gold"><Download size={18} /></button>
          </div>
        ))}
      </Card>
    </div>
  );
}
